export const productPaths = {
	PRODUCT: "",
};
